import { Combination, Option, OptionGroup, Variant } from '../ecwidTypes';

const getCombinationOptions = (
    combination: Combination,
    options: Option[],
): OptionGroup[] =>
    combination.options.map(option => {
        const optionType =
            options.find(opt => opt.name === option.name)?.type || 'UNKNOWN';

        return {
            name: option.name,
            type: optionType,
            choices: [{ label: option.value, value: option.value }],
        };
    });

export const getVariants = (
    combinations: Combination[],
    options: Option[],
): Variant[] => {
    return combinations.flatMap(combination => {
        const disabled = !combination.unlimited && !combination.inStock;

        return getCombinationOptions(combination, options).flatMap(
            optionGroup =>
                optionGroup.choices.map(
                    choice =>
                        ({
                            ...combination,
                            id: `${combination.id}-${choice.value}`,
                            optionName: optionGroup.name,
                            type: optionGroup.type,
                            label: choice.label,
                            value: choice.value,
                            disabled,
                        }) as unknown as Variant,
                ),
        );
    });
};

export const groupVariants = (
    variants: Variant[],
): Record<string, Variant[]> => {
    return variants.reduce(
        (acc, variant) => {
            if (!acc[variant.optionName]) {
                acc[variant.optionName] = [];
            }
            acc[variant.optionName].push(variant);
            return acc;
        },
        {} as Record<string, Variant[]>,
    );
};

export function getCategoryIdFromUrl(url: string): number | null {
    const match = url.match(/c(\d+)/);
    return match ? parseInt(match[1], 10) : null;
}

export function getProductIdFromUrl(url: string): number | null {
    const match = url.match(/p(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
}
